export default (() => {
    const intersectionToggles = Array.from(
        document.querySelectorAll('.js-scroll-intersection-toggle')
    );

    const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.2
    };

    intersectionToggles.forEach((toggleEl) => {
        const scrollTarget = document.querySelector(`#${toggleEl.dataset.scrollTarget}`);

        const observer = new IntersectionObserver((event) => {
            toggleEl.classList[event[0].isIntersecting ? 'add' : 'remove']('toggled');
        }, options);

        if (scrollTarget) observer.observe(scrollTarget);
    });
})();
